var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrames(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 130",
    style: {
      enableBackground: "new 0 0 130 130"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#848484;}\n\t.st2{fill:#F2F2F2;}\n\t.st3{fill:#9A9999;}\n\t.st4{opacity:0.23;fill:#FFFFFF;enable-background:new    ;}\n\t.st5{fill:#313131;}\n\t.st6{fill:#FABC99;}\n\t.st7{fill:#E2A181;}\n\t.st8{fill:#D96E82;}\n\t.st9{fill:#27150E;}\n\t.st10{fill:#DDDDDC;}\n\t.st11{fill:#E8E8E8;}\n\t.st12{fill:#FFFFFF;}\n\t.st13{fill:#CDCCCC;}\n\t.st14{opacity:0.29;}\n\t.st15{fill:#728285;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2969",
    className: "st0",
    width: 130,
    height: 130
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5709",
    className: "st1",
    d: "M37.8,66.7c0.3,0.9,0.7,1.7,1.1,2.5c0.2,0.3,0.3,0.7,0.5,1c0.2,0.5,0.5,0.9,0.7,1.4v-4.9 C39.3,66.8,38.6,66.8,37.8,66.7z M86,7H44.8c-5,0.1-8.9,4.3-8.8,9.3V113c0,0.1,0,0.3,0,0.4v0.1c0,0.1,0,0.1,0,0.2 c0,0.1,0,0.1,0,0.2v0c0,0.1,0,0.3,0.1,0.4c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0.1,0.3c0,0,0,0,0,0.1c0,0.1,0,0.2,0.1,0.3 c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0.1,0.2,0.1,0.3c0,0,0,0.1,0,0.1c0,0.1,0.1,0.2,0.1,0.3c0.2,0.5,0.4,0.9,0.6,1.3 c0.1,0.2,0.3,0.5,0.4,0.7c0.3,0.5,0.7,0.9,1.1,1.3c0.1,0.1,0.2,0.2,0.3,0.3s0.2,0.2,0.3,0.3c0.2,0.1,0.3,0.3,0.5,0.4 c0.1,0.1,0.2,0.1,0.2,0.2c0.1,0,0.2,0.1,0.3,0.2s0.2,0.1,0.3,0.2s0.2,0.1,0.3,0.2c0,0,0,0,0.1,0c0.1,0.1,0.2,0.1,0.3,0.1 c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0.1,0.2,0.1c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.2,0.1,0.4,0.1 c0.3,0.1,0.5,0.1,0.8,0.1c0.3,0,0.6,0,0.9,0H86c4.7-0.1,8.5-3.8,8.7-8.5c0-0.1,0-0.1,0-0.2l0,0c0-0.2,0-0.3,0-0.5V16.3 C94.9,11.3,91,7.2,86,7C86,7,86,7,86,7L86,7z M90.7,107.4H40.1V21.9h50.7V107.4z M37.8,66.7c0.3,0.9,0.7,1.7,1.1,2.5 c0.2,0.3,0.3,0.7,0.5,1c0.2,0.5,0.5,0.9,0.7,1.4v-4.9C39.3,66.8,38.6,66.8,37.8,66.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2394",
    x: 37.7,
    y: 21.9,
    className: "st2",
    width: 55.8,
    height: 85.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5712",
    className: "st3",
    d: "M85.4,14.6c0,1.2-1,2.3-2.3,2.3s-2.3-1-2.3-2.3c0-1.2,1-2.3,2.2-2.3 C84.4,12.3,85.4,13.3,85.4,14.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1627",
    transform: "translate(0 0.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5723",
    className: "st4",
    d: "M57.6,7l-0.6,14.8l-3.5,85.5l-0.6,14.8H44c-5-0.1-8.9-4.3-8.8-9.3V16.3 c-0.1-5,3.8-9.1,8.8-9.3L57.6,7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1640",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2395",
    x: 47.8,
    y: 74.1,
    className: "st5",
    width: 35.8,
    height: 29.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2396",
    x: 61,
    y: 87.7,
    className: "st6",
    width: 8.2,
    height: 6.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5740",
    className: "st7",
    d: "M67.5,90c0.6,0,1.2,0.1,1.7,0.2v-2.5H61v6.8C62,91.7,64.6,89.8,67.5,90z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5741",
    className: "st6",
    d: "M68.7,93.5h-7c0,0-14.1-0.8-16.8,13.8h40.6C82.7,92.8,68.7,93.5,68.7,93.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5742",
    className: "st6",
    d: "M82,67.8c0,11.9-7,21.6-16.9,21.6s-16.9-9.7-16.9-21.6s7-21.6,16.9-21.6S82,55.8,82,67.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1634",
    transform: "translate(34.931 28.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5743",
    className: "st6",
    d: "M44.9,44.6c-0.4,1.9,0.3,3.6,1.5,3.8s2.4-1.1,2.8-3s-0.3-3.6-1.5-3.8S45.3,42.7,44.9,44.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5744",
    className: "st7",
    d: "M47.1,43.4c0,0,0.1,0,0.2,0.1c0.1,0,0.2,0.1,0.2,0.1c0.1,0.1,0.1,0.1,0.2,0.2 c0.1,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0,0.2,0.1,0.3c0,0.3,0,0.6-0.1,0.8c-0.1,0.3-0.1,0.6-0.3,0.8c-0.1,0.2-0.2,0.4-0.4,0.6 c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.2,0.1-0.2,0c-0.1,0-0.2,0-0.2,0c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.1 c0.1,0,0.3,0,0.4-0.1c0.3-0.1,0.5-0.4,0.7-0.6c0.2-0.3,0.3-0.6,0.4-1c0-0.2,0.1-0.4,0.1-0.5c0-0.2,0-0.4-0.1-0.5 c0-0.2-0.1-0.3-0.2-0.5c0-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0-0.2,0-0.3,0 C47.2,43.4,47.1,43.4,47.1,43.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1635",
    transform: "translate(1.175 28.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5745",
    className: "st6",
    d: "M49.2,44.6c0.4,1.9-0.3,3.6-1.5,3.8s-2.4-1.1-2.8-3s0.3-3.6,1.5-3.8S48.9,42.7,49.2,44.6z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5746",
    className: "st7",
    d: "M47.1,43.4c0,0-0.1,0-0.2,0.1c-0.1,0-0.2,0.1-0.2,0.1c-0.1,0.1-0.1,0.1-0.2,0.2 c-0.1,0.1-0.1,0.2-0.1,0.3c-0.1,0.1,0,0.2-0.1,0.3c0,0.3,0,0.6,0.1,0.8c0.1,0.3,0.1,0.6,0.3,0.8c0.1,0.2,0.2,0.4,0.4,0.6 c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0,0.2,0.1,0.2,0c0.1,0,0.2,0,0.2,0c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.2,0.1-0.3,0.1 c-0.1,0-0.3,0-0.4-0.1c-0.3-0.1-0.5-0.4-0.7-0.6c-0.2-0.3-0.3-0.6-0.4-1c0-0.2-0.1-0.4-0.1-0.5c0-0.2,0-0.4,0.1-0.5 c0-0.2,0.1-0.3,0.2-0.5c0.1-0.1,0.1-0.1,0.2-0.2l0.2-0.1c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0,0.2,0,0.3,0C46.9,43.4,47,43.4,47.1,43.4 z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5747",
    className: "st8",
    d: "M79.2,107.4h-27c4.7-3.6,1.3-12,1.3-12c0.9-0.4,1.9-0.8,2.9-1.1c0,0,8.8,10.8,17.6,0 c1.3,0.4,2.5,0.9,3.7,1.5C77.6,95.8,72.8,103.8,79.2,107.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5748",
    className: "st9",
    d: "M48.3,69.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5749",
    className: "st9",
    d: "M57.7,46.5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1637",
    transform: "translate(2.464 33.638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1636"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5750",
    className: "st10",
    d: "M47.1,42.7c0,0.6-0.5,1.1-1.1,1.1c0,0,0,0,0,0c-0.6,0-1.1-0.5-1.1-1.1c0,0,0,0,0,0 c0-0.6,0.5-1.1,1.1-1.1c0,0,0,0,0,0C46.6,41.6,47.1,42.1,47.1,42.7C47.1,42.7,47.1,42.7,47.1,42.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5751",
    className: "st11",
    d: "M47,43.1c-0.2,0.2-0.4,0.3-0.6,0.3c-0.2,0-0.5-0.1-0.6-0.3c-0.2-0.2-0.3-0.4-0.3-0.6v0 c0-0.2,0.1-0.5,0.3-0.6c0.1-0.1,0.2-0.2,0.4-0.2c0,0-0.1,0-0.1,0c-0.6,0-1.1,0.5-1.1,1.1c0,0,0,0,0,0c0,0.6,0.5,1.1,1.1,1.1 c0,0,0,0,0,0C46.5,43.9,46.9,43.5,47,43.1C47.1,43.1,47.1,43.1,47,43.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5752",
    className: "st12",
    d: "M46.8,42.4c0,0.2-0.2,0.4-0.4,0.4c0,0,0,0,0,0c-0.2,0-0.4-0.2-0.4-0.4c0,0,0,0,0,0 c0-0.2,0.2-0.4,0.4-0.4C46.6,42,46.8,42.1,46.8,42.4L46.8,42.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1639",
    transform: "translate(35.489 33.638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1638"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5753",
    className: "st10",
    d: "M47.1,42.7c0,0.6-0.5,1.1-1.1,1.1c0,0,0,0,0,0c-0.6,0-1.1-0.5-1.1-1.1c0,0,0,0,0,0 c0-0.6,0.5-1.1,1.1-1.1c0,0,0,0,0,0C46.6,41.6,47.1,42.1,47.1,42.7C47.1,42.7,47.1,42.7,47.1,42.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5754",
    className: "st11",
    d: "M47,43.1c-0.2,0.2-0.4,0.3-0.6,0.3c-0.2,0-0.5-0.1-0.6-0.3c-0.2-0.2-0.3-0.4-0.3-0.6v0 c0-0.2,0.1-0.5,0.3-0.6c0.1-0.1,0.2-0.2,0.4-0.2c0,0-0.1,0-0.1,0c-0.6,0-1.1,0.5-1.1,1.1c0,0,0,0,0,0c0,0.6,0.5,1.1,1.1,1.1 c0,0,0,0,0,0C46.5,43.9,46.9,43.5,47,43.1C47.1,43.1,47.1,43.1,47,43.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5755",
    className: "st12",
    d: "M46.8,42.4c0,0.2-0.2,0.4-0.4,0.4c0,0,0,0,0,0c-0.2,0-0.4-0.2-0.4-0.4c0,0,0,0,0,0 c0-0.2,0.2-0.4,0.4-0.4S46.8,42.1,46.8,42.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5756",
    className: "st5",
    d: "M63.7,48.7c0,0,2.5,9.2,16.4,14.3c0,0,1.8,1.4,1.5,7.6c0,0,0.7-1.5,2,0 c0,0,2.7-14.2-2.2-21.9c0,0-5.9-8.2-15.8-7C65.7,41.7,62.4,43.4,63.7,48.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5757",
    className: "st5",
    d: "M66.7,48.7c0,0-2.5,9.2-16.4,14.3c0,0-1.8,1.4-1.5,7.6c0,0-0.7-1.5-2,0 c0,0-2.7-14.2,2.2-21.9c0,0,5.9-8.2,15.8-7C64.8,41.7,68,43.4,66.7,48.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5732",
    className: "st13",
    d: "M76.1,14.6c0,0.6-0.5,1.1-1.1,1.1c0,0,0,0,0,0H56.1c-0.6,0-1.1-0.5-1.1-1.1l0,0 c0-0.6,0.5-1.1,1.1-1.1c0,0,0,0,0,0H75C75.6,13.5,76.1,14,76.1,14.6C76.1,14.5,76.1,14.5,76.1,14.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1632",
    transform: "translate(0.754 100.374)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5737",
    className: "st15",
    d: "M35.3,13.3c0-0.2,0-0.5,0-0.8v-2.4c1.3-0.7,2.3-1.8,2.9-3.1h0.2 C39.2,9.4,37.6,11.9,35.3,13.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrames);
export default __webpack_public_path__ + "static/media/frames.ffb5b157def3631401d9b938cd086e2f.svg";
export { ForwardRef as ReactComponent };